<template>
  <div class="notifications-alert">
    <v-fade-transition
      v-for="(notification, index) in alertNotifications"
      :key="index"
    >
      <div :class="['notification mt-2 shadow-base', notification.type]">
        <div
          v-if="notification.type === 'annoucement'"
          class="pa-5 primary rounded-10"
        >
          <div class="d-flex align-baseline">
            <div class="flex-1 text-4 font-weight-medium white--text line-height-24">
              {{ notification.title }}
            </div>
            <div class="ml-5 white--text opacity-8 text-5 font-weight-medium">Just now</div>
          </div>
          <div
            class="mt-3 text-5 white--text opacity-8 line-height-24 annoucement-message"
          >
            <div v-html="notification.message"></div>
          </div>
        </div>
        <div
          v-if="notification.type === 'transaction'"
          class="p-relative border-default rounded-10 pa-5 clickable transaction"
        >
          <div class="indicator primary"></div>
          <div class="d-flex align-flex-start">
            <div class="flex-1 d-flex align-center">
              <img :src="notification.icon" alt="" width="24px" height="16px" />
              <div class="flex-1 ml-3 text-4 font-weight-medium line-height-24">
                {{ $t(notification.title, notification.metadata) }}
              </div>
            </div>
            <div class="ml-5 text-5 font-weight-medium primary--text">Just now</div>
          </div>
          <div class="mt-3 line-height-24 text-5 font-weight-medium">
            {{ $t(notification.message, notification.metadata) }}
          </div>
          <div class="mt-3 text-right">
            <a
              :href="notification.link"
              target="_blank"
              rel="noopener noreferrer"
              class="primary--text text-decoration-none text-5 font-weight-medium"
              >View Transaction</a
            >
          </div>
        </div>
      </div>
    </v-fade-transition>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      alertNotifications: "notification/alertNotifications",
    }),
  },
  methods: {
    removeAlert(id) {
      this.$store.dispatch("notification/removeAlertNoti", id);
    },
  },
  mounted() {
    setInterval(() => {
      this.alertNotifications
        .filter((al) => al.expiry - new Date().valueOf() < 0)
        .map((al) => al.id)
        .forEach(this.removeAlert);
    }, 100);
  },
};
</script>
<style lang="scss">
.notifications-alert {
  .notification {
    width: 420px;
    max-width: calc(100vw - 40px);
    .transaction {
      background-color: white;
    }
    .indicator {
      left: 5px;
      top: 5px;
      position: absolute;
      width: 6px;
      height: calc(100% - 10px);
      border-radius: 50px;
    }
    .annoucement-message {
      a {
        color: white !important;
      }
    }
  }
  .line-height-24 {
    line-height: 24px !important;
  }
}
.theme--dark {
  .notifications-alert {
    .transaction {
      background-color: #222e3b !important;
    }
  }
}
</style>